import React from 'react';
import styled from 'styled-components';
import { LinkedIn, Twitter, Instagram, GitHub } from '@mui/icons-material';
import { Bio } from '../../data/constants';

const Foot = styled.footer`
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.bg};
  padding: 0;
`;

const TopDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(34,211,238,0.25), transparent);
`;

const WatermarkWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 5vw 0;
  overflow: hidden;
`;

const Watermark = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(64px, 14vw, 180px);
  font-weight: 900;
  letter-spacing: -0.04em;
  color: transparent;
  -webkit-text-stroke: 1px rgba(34, 211, 238, 0.07);
  user-select: none;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
  pointer-events: none;
`;

const Inner = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1100px;
  margin: 0 auto;
  padding: 28px 5vw 48px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 32px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const NameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 640px) { justify-content: center; }
`;

const NameText = styled.span`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.01em;
`;

const Dot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22D3EE;
  box-shadow: 0 0 6px #22D3EE;
  animation: dot-blink 2s ease-in-out infinite;
  flex-shrink: 0;
`;

const Sub = styled.p`
  font-size: 12.5px;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0.6;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 14px;

  @media (max-width: 640px) { align-items: center; }
`;

const Socials = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SocialBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  transition: border-color 0.2s, color 0.2s, transform 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    transform: translateY(-3px);
    box-shadow: 0 4px 16px rgba(34, 211, 238, 0.2);
  }
`;

const MadeWith = styled.p`
  font-size: 11px;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0.45;
  letter-spacing: 0.04em;
`;

function Footer() {
  return (
    <Foot>
      <TopDivider />

      <WatermarkWrap>
        <Watermark>AMAN SINGH</Watermark>
      </WatermarkWrap>

      <Inner>
        <Left>
          <NameRow>
            <Dot />
            <NameText>Aman Singh</NameText>
          </NameRow>
          <Sub>© {new Date().getFullYear()} · Full Stack Developer · Bengaluru, India</Sub>
        </Left>

        <Right>
          <Socials>
            <SocialBtn href={Bio.github}   target="_blank" rel="noopener noreferrer" aria-label="GitHub"><GitHub   fontSize="small" /></SocialBtn>
            <SocialBtn href={Bio.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedIn fontSize="small" /></SocialBtn>
            <SocialBtn href={Bio.twitter}  target="_blank" rel="noopener noreferrer" aria-label="Twitter"><Twitter  fontSize="small" /></SocialBtn>
            <SocialBtn href={Bio.insta}    target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram fontSize="small" /></SocialBtn>
          </Socials>
          <MadeWith>Built with React · Designed by Aman</MadeWith>
        </Right>
      </Inner>
    </Foot>
  );
}

export default Footer;
